export const toUrl = (p) => (p && p.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${p}` : p);
export const API = process.env.REACT_APP_BACKEND_URL;

export const COPY = {
  welcome: [
    "Roll out the red carpet, fluff up those wrinkles and strike your best Bulldog pose!",
    "Welcome to The Pawparazzi Red Carpet, where our Pup of the Month winners receive the full celebrity treatment!",
    "From stretch limousine arrivals to exclusive interviews with our two highly questionable roving reporters, Chewie and Solo, this is where Bulldog royalty gets its moment in the spotlight.",
    "The cameras are flashing, the biscuits are disappearing, and the questions are getting more ridiculous by the minute!",
  ],
  crown: (name, month, hearts) => [
    "The hearts have been counted, the wrinkles have been inspected, and Chewie and Solo have finally agreed on something!",
    "Ladies and gentlepups, please put your paws together for…",
    `🏆 ${name} 🏆`,
    `Our official ${month} Pup of the Month!`,
    `With ${hearts} verified heart${hearts === 1 ? "" : "s"}, this gorgeous Bulldog has captured the crown and earned a first-class ticket to The Pawparazzi Red Carpet!`,
    "The limousine is being polished, the paparazzi are gathering, and Chewie and Solo are preparing their very important interview questions.",
    "Stay tuned — our newest Bulldog superstar is about to receive the full VIP treatment!",
  ],
  countdown: [
    "The limousine is booked, the red carpet has been rolled out, and our two roving reporters are preparing for the biggest interview of their careers!",
    "Chewie has been practising her questions.",
    "Solo has been practising his biscuit consumption.",
    "And our latest Bulldog superstar is almost ready to make their grand entrance!",
    "The Pawparazzi Red Carpet premiere begins in…",
  ],
  premiere: [
    "The red carpet is ready, the paparazzi are in position, and the stretch limousine has officially arrived!",
    "It's time to welcome our newest Bulldog superstar to The Pawparazzi Red Carpet!",
    "Join Chewie and Solo as they roll out the royal treatment, ask the questions nobody requested, and discover what life is really like for our newly crowned Pup of the Month!",
    "Grab your popcorn, hide your biscuits and prepare for a celebrity experience unlike any other!",
  ],
  homepage: [
    "Move over Hollywood — Bulldog royalty has arrived!",
    "Join Chewie and Solo, our two rather questionable celebrity reporters, as they welcome our Pup of the Month winners to the red carpet.",
    "Expect glamour, giggles, exclusive interviews and a suspicious number of missing biscuits!",
  ],
};

export const fmtBrisbane = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("en-AU", { timeZone: "Australia/Brisbane", weekday: "long", day: "numeric", month: "long", year: "numeric", hour: "numeric", minute: "2-digit" }) + " (Brisbane time)"; }
  catch { return iso; }
};

export const shareLinks = (url, title) => ({
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(title)}`,
  whatsapp: `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`,
  pinterest: (img) => `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(img || "")}&description=${encodeURIComponent(title)}`,
  email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${title}\n\n${url}`)}`,
});
